var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78.5 82.5",
    style: {
      enableBackground: "new 0 0 78.5 82.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.me0{fill:#521159;}\n\t.me1{fill:#FFC5C0;}\n\t.me2{fill:#330434;}\n\t.me3{fill:#39003C;}\n\t.me4{fill:#FFFFFF;}\n\t.me5{enable-background:new    ;}\n\t.me6{fill:#FAE9E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLAYER",
    transform: "translate(-85.311 -20.682)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15_00000032631299796593630140000007105260253931209617_",
    className: "me0",
    cx: 125.4,
    cy: 66.6,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_271_00000175284286211348485070000003252211210354425232_",
    transform: "translate(109.151 39.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1158_00000150808250677131563380000014011221685229312657_",
    className: "me1",
    d: "M11.1,0.6L5.2,3.9l-2.3,6.1L3.8,18 l-2,0.3l-1.4,2.9l1.7,4.3l2.5,1.1l1.9-1.1l1.9,6l8.9,4l5.3,0.3l5.8-1.7l3.3-6.8l-0.6-3.9l0.8-8l-0.4-3.9l-0.4-4.4l-0.9-3l-9.2-3.7 H11.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_270_00000160876128802229130390000014111781844898315395_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_269_00000091014970661563912240000002269627164187052928_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1159_00000106130405845231176020000011218277454667516083_",
    className: "me2",
    d: "M4.7,23.8c0,0,1.1-0.3,1.1-2 S3.5,18.7,3,19.2s1.7,1.3,1.6,2.3S3.6,24.1,4.7,23.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1160_00000155144107867587275830000002902430360530144934_",
    className: "me1",
    d: "M8.1,29.7l3.4,4.7l12.7,3.4 l0.8,3.3l-5,1.9l-7.6-1.9l-4.4-2.4v-6.1L8.1,29.7z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1169",
    className: "me2",
    d: "M132.8,59.6c0.2,0.2,0.5,0.5,0.7,0.8c0.2,0.3,0.4,0.5,0.6,0.8l0,0.1l0,0c0,0,0,0,0,0.1 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.2,0.4-0.3,0.5c-0.2,0.3-0.5,0.5-0.8,0.8l-0.3-0.2c0.1-0.3,0.3-0.6,0.5-0.9 c0.1-0.1,0.1-0.3,0.2-0.4c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1c-0.2-0.3-0.4-0.6-0.5-0.9 c-0.2-0.3-0.3-0.6-0.5-0.9L132.8,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1172",
    className: "me2",
    d: "M126.6,57.1c0.5-0.6,1.2-1,2-0.8c1.4,0.2,1.9,1.1,1.5,2.1c-0.4,1-1,1.4-1.6,1.1 s-0.9-0.4-0.7-1.8c-0.9,0-1.6,0.5-1.5,0.1C126.4,57.6,126.4,57.3,126.6,57.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1173",
    className: "me2",
    d: "M136,57.4c0.4-0.6,1.1-0.9,1.9-0.7c1.3,0.2,1.7,1,1.4,1.9c-0.3,1-0.9,1.3-1.4,1 c-0.5-0.3-0.8-0.4-0.6-1.7c-0.8,0-1.4,0.4-1.4,0.1C135.8,57.8,135.9,57.6,136,57.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1175",
    className: "me3",
    d: "M134.9,53.2c0,0,2.6-0.8,4-0.4c0.7,0.2,1.3,0.6,1.8,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    className: "me3",
    d: "M124.2,53.4c0,0,2.4-1.2,3.8-1c0.7,0.1,1.4,0.4,1.9,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1177",
    className: "me4",
    d: "M128.8,66c0,0,5.7-0.2,7.1,0c1.4,0.2,0,2.2-0.6,2.7c-1.3,0.7-2.8,0.8-4.2,0.2 C129.7,68.3,127.6,67,128.8,66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "me5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M89.2,100.6h-1.6l-0.4,2h-0.7l0.4-2h-1.1l0.1-0.7H87l0.4-1.8h-1.2l0.1-0.7h1.2l0.4-1.9h0.7l-0.4,1.9h1.6 l0.4-1.9h0.7l-0.4,1.9h1.2l-0.1,0.7h-1.2L90,99.9h1.3l-0.1,0.7h-1.3l-0.4,2h-0.7L89.2,100.6z M89.3,99.9l0.4-1.8H88l-0.4,1.8H89.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M94.9,95.5c1.3,0,2.3,0.9,2.3,2.3c0,1.3-0.9,2.3-2.3,2.3h-1.6v2.5h-0.9v-7H94.9z M93.3,99.3h1.4 c1,0,1.6-0.6,1.6-1.5c0-0.9-0.6-1.5-1.6-1.5h-1.4V99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M98.1,97.5h0.8v0.8h0c0.2-0.6,0.6-0.9,1.2-0.9c0.1,0,0.3,0,0.3,0v0.8c-0.1,0-0.2,0-0.5,0 c-0.7,0-1.1,0.5-1.1,1.2v3.2h-0.8V97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M100.7,100c0-1.6,0.9-2.6,2.4-2.6c1.4,0,2.3,1,2.3,2.6c0,1.6-0.9,2.6-2.3,2.6 C101.6,102.7,100.7,101.6,100.7,100z M104.5,100c0-1.2-0.6-1.9-1.5-1.9s-1.5,0.7-1.5,1.9s0.6,1.9,1.5,1.9S104.5,101.2,104.5,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M106.5,98.2h-0.7v-0.7h0.7v-0.6c0-1,0.5-1.4,1.4-1.4c0.2,0,0.4,0,0.5,0v0.7c-0.1,0-0.2,0-0.4,0 c-0.5,0-0.7,0.2-0.7,0.7v0.6h1v0.7h-1v4.4h-0.8V98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M113.2,101.1c-0.1,0.9-1,1.5-2.1,1.5c-1.5,0-2.3-1-2.3-2.6c0-1.6,0.9-2.6,2.3-2.6c1.4,0,2.2,1,2.2,2.5v0.3 h-3.6v0c0,1,0.6,1.6,1.5,1.6c0.6,0,1.1-0.3,1.3-0.8H113.2z M109.6,99.6h2.8c0-0.8-0.6-1.5-1.4-1.5 C110.2,98.1,109.7,98.8,109.6,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M115.9,97.4c1.1,0,1.9,0.7,1.9,1.6H117c-0.1-0.5-0.5-0.9-1.1-0.9c-0.6,0-1,0.3-1,0.8c0,0.4,0.3,0.6,0.8,0.7 l0.8,0.2c1,0.2,1.4,0.6,1.4,1.4c0,0.9-0.8,1.5-2,1.5c-1.2,0-1.9-0.6-2-1.6h0.8c0.1,0.6,0.5,0.9,1.2,0.9s1.1-0.3,1.1-0.8 c0-0.4-0.2-0.6-0.8-0.7l-0.8-0.2c-1-0.2-1.4-0.7-1.4-1.4C114,98,114.8,97.4,115.9,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M120.6,97.4c1.1,0,1.9,0.7,1.9,1.6h-0.8c-0.1-0.5-0.5-0.9-1.1-0.9c-0.6,0-1,0.3-1,0.8c0,0.4,0.3,0.6,0.8,0.7 l0.8,0.2c1,0.2,1.4,0.6,1.4,1.4c0,0.9-0.8,1.5-2,1.5c-1.2,0-1.9-0.6-2-1.6h0.8c0.1,0.6,0.5,0.9,1.2,0.9s1.1-0.3,1.1-0.8 c0-0.4-0.2-0.6-0.8-0.7l-0.8-0.2c-1-0.2-1.4-0.7-1.4-1.4C118.7,98,119.5,97.4,120.6,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M127.6,101.1c-0.1,0.9-1,1.5-2.1,1.5c-1.5,0-2.3-1-2.3-2.6c0-1.6,0.9-2.6,2.3-2.6c1.4,0,2.2,1,2.2,2.5v0.3 h-3.6v0c0,1,0.6,1.6,1.5,1.6c0.6,0,1.1-0.3,1.3-0.8H127.6z M124.1,99.6h2.8c0-0.8-0.6-1.5-1.4-1.5 C124.7,98.1,124.1,98.8,124.1,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M132.7,102.6h-0.8v-0.8h0c-0.3,0.6-0.8,0.9-1.6,0.9c-1.1,0-1.8-0.7-1.8-1.9v-3.3h0.8v3.1 c0,0.8,0.4,1.3,1.2,1.3c0.8,0,1.3-0.6,1.3-1.4v-3h0.8V102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M133.8,97.5h0.8v0.8h0c0.2-0.6,0.6-0.9,1.2-0.9c0.1,0,0.3,0,0.3,0v0.8c-0.1,0-0.2,0-0.5,0 c-0.7,0-1.1,0.5-1.1,1.2v3.2h-0.8V97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M139,99L139,99l-2.4-3.5h1.1l1.9,2.8h0l1.9-2.8h1l-2.4,3.5v0l2.4,3.5h-1.1l-1.9-2.8h0l-1.9,2.8h-1L139,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M142.9,101.1c0-0.9,0.7-1.4,1.8-1.5l1.5-0.1v-0.4c0-0.6-0.4-1-1.1-1c-0.7,0-1.1,0.3-1.2,0.8H143 c0.1-0.9,0.8-1.6,2-1.6c1.2,0,1.9,0.6,1.9,1.7v3.5h-0.8v-0.9h0c-0.3,0.6-0.9,1-1.6,1C143.5,102.7,142.9,102,142.9,101.1z  M146.2,100.6v-0.4l-1.4,0.1c-0.7,0-1.1,0.3-1.1,0.8c0,0.5,0.4,0.8,1,0.8C145.5,101.9,146.2,101.4,146.2,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M150.4,102.6h-0.9l-1.9-5.1h0.9l1.4,4.2h0l1.4-4.2h0.9L150.4,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M152.8,96.1c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5 C153.1,96.6,152.8,96.3,152.8,96.1z M153,97.5h0.8v5.1H153V97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M159.2,101.1c-0.1,0.9-1,1.5-2.1,1.5c-1.5,0-2.3-1-2.3-2.6c0-1.6,0.9-2.6,2.3-2.6c1.4,0,2.2,1,2.2,2.5v0.3 h-3.6v0c0,1,0.6,1.6,1.5,1.6c0.6,0,1.1-0.3,1.3-0.8H159.2z M155.6,99.6h2.8c0-0.8-0.6-1.5-1.4-1.5 C156.2,98.1,155.6,98.8,155.6,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "me6",
    d: "M160.1,97.5h0.8v0.8h0c0.2-0.6,0.6-0.9,1.2-0.9c0.1,0,0.3,0,0.3,0v0.8c-0.1,0-0.2,0-0.5,0 c-0.7,0-1.1,0.5-1.1,1.2v3.2h-0.8V97.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_406",
    transform: "translate(100.398 20.682)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1623",
    className: "me6",
    d: "M7.7,10.2c0.7,1.4,0.2,3.1-1.2,3.9c-1.5,1.2-3.7,1-5-0.6c-0.1-0.1-0.2-0.2-0.2-0.3 c-1.3-1.5-1.2-3.7,0.3-5C1.7,8.1,1.8,8,1.9,7.9c1.1-1.1,2.9-1.1,4,0L5.3,8.8c-0.8-0.7-2-0.7-2.7,0c0,0-1.9,1.4-0.3,3.6 s3.5,0.8,3.5,0.8c1.8-1.3,0.8-2.6,0.8-2.6L7.7,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1624",
    className: "me6",
    d: "M6.9,7.2L6,5.3L7,4.8L8,7L6.9,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1625",
    className: "me6",
    d: "M14.6,6.1L11,8.2c0.3,0.8,1.1,1.2,1.9,0.9C13,9.1,13,9,13.1,9c0.7-0.2,1-0.9,0.8-1.6 l1.2-0.1c0.3,1.2-0.4,2.3-1.5,2.7c-1.5,0.6-3.2-0.1-3.8-1.6c-0.6-1.4,0.1-3.1,1.5-3.7c1.1-0.6,2.5-0.2,3.1,1 c0,0.1,0.1,0.1,0.1,0.2L14.6,6.1z M10.7,7.4l2.6-1.5c-0.1-0.2-0.6-0.8-1.8-0.1C11.5,5.8,10.2,6.4,10.7,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1626",
    className: "me6",
    d: "M18.6,5c1.2,0.1,1.9,0.2,2.1,1c0.5,1.9-2.1,2.3-2.1,2.3c-1.1,0.3-2.4-0.2-3-1.2l1-0.7 c0.4,0.6,1,0.9,1.7,0.8c0,0,1.3-0.2,1.1-0.9c-0.1-0.4-1-0.4-1-0.4l-1.8-0.1c-0.7,0.1-1.3-0.4-1.5-1c-0.4-1.7,2.1-2.2,2.1-2.2 c1.1-0.4,2.4,0.1,2.9,1.3l-1,0.6c-0.2-0.7-1-1-1.6-0.8c0,0-1.2,0.2-1.1,0.9c0,0,0.1,0.3,0.7,0.3L18.6,5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1627",
    className: "me6",
    d: "M20.8,2c0.8-0.1,0.7-1.3,0.7-1.3l0.7-0.1l0.1,1.2l1-0.1l0.1,0.9l-1,0.1l0.3,2.9 c0,0,0.1,0.8,1.1,0.6L24,7.5c-0.3,0.1-0.6,0.1-0.9,0c-0.9-0.2-1.5-1-1.5-1.9l-0.3-2.7L20.7,3L20.6,2L20.8,2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1628",
    className: "me6",
    d: "M31.4,1.9L32.7,2l-2.5,5.6l-1.2-0.1l-1.5-6l1.2,0.1l0.9,4.3l0.2,0L31.4,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1629",
    className: "me6",
    d: "M34.6,8.4c-0.8-0.2-2.6-0.9-1.9-3.5c0.6-2.6,2.5-2.4,3.3-2.2c0.8,0.2,2.6,0.9,1.9,3.5 C37.3,8.7,35.4,8.6,34.6,8.4 M36.7,5.9c0.4-1.6-0.5-2-1-2.1c-0.5-0.1-1.5-0.2-1.9,1.4c-0.4,1.6,0.5,2,1,2.1 C35.3,7.4,36.3,7.5,36.7,5.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1630",
    className: "me6",
    d: "M43.5,5.3l1.1,0.5l-2.3,5.3l-1.2-0.5L42,9.3l-0.3-0.1c-0.4,0.8-1.3,1.1-2.1,0.8 c-2.3-0.8-1.1-3.1-1.1-3.1l1.3-3.1l1.1,0.5L39.8,7c0,0-0.8,1.6,0.4,2.1c0.8,0.3,1.7,0,2-0.8c0,0,0-0.1,0-0.1L43.5,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1631",
    className: "me6",
    d: "M46.9,10.2c0.8,0.9,1.2,1.5,0.7,2.2c-1,1.6-3.1,0.1-3.1,0.1c-1-0.6-1.5-1.8-1.2-3l1.2,0.3 c-0.2,0.7,0.1,1.4,0.6,1.8c0,0,1,0.8,1.4,0.2c0.2-0.4-0.4-1-0.4-1L45,9.5c-0.5-0.4-0.7-1.2-0.3-1.8c0.9-1.5,3,0,3,0 c1.1,0.5,1.6,1.8,1.1,2.9l-1.1-0.3c0.3-0.6,0.1-1.4-0.5-1.8c0,0-1-0.7-1.4-0.1c0,0-0.2,0.3,0.3,0.7L46.9,10.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer1);
export default __webpack_public_path__ + "static/media/player-1.91dcb37db9b3d41639ce06c6aff3f0b0.svg";
export { ForwardRef as ReactComponent };